export default __webpack_public_path__ + "fonts/seatch-connect.svg";